import Vue from 'vue'

/**
 * directive: 数値を整数にし、３桁区切りの価格表記に修正する
 * <span v-price="{{ Number }}"></span>
 * @attr { Boolean } data-add-tax - 税率を足した状態で価格を表示する
 * example:
 * <span v-price="1000" data-add-tax="true"></span> => ¥990
 */
const taxRate = 0.10

const getPriceString = (el, bindings) => {
  let { value } = bindings
  let tax = el.dataset.addTax ? taxRate : 0
  let price = Number(value) + Math.floor(Number(value) * tax)
  price = isNaN(price) ? '---' : price.toLocaleString()
  return price
}

Vue.directive('price', {
  bind(el, bindings) {
    Object.assign(el, {
      textContent: `¥${getPriceString(el, bindings)}`
    })
  },
  update(el, bindings) {
    Object.assign(el, {
      textContent: `¥${getPriceString(el, bindings)}`
    })
  }
})



// WEBPACK FOOTER //
// ./resources/assets/js/directive/price.js